export default {
  mounted(el) {
    el.style.position = "absolute";
    el.style.cursor = "grab";
    el.style.userSelect = "none";
    el.style.zIndex = 10;

    let shiftX = 0, shiftY = 0;
    let dragging = false;

    const isInteractive = (target) => {
      return !!target.closest(
        `
        input, textarea, select, option, button, a, label,
        [contenteditable='true'],
        .no-drag,
        .ant-slider, .ant-slider-handle, .ant-slider-track, .ant-slider-rail
        `
      );
    };
    

    const onMouseMove = (event) => {
      if (!dragging) return;

      let newX = event.clientX - shiftX;
      let newY = event.clientY - shiftY;

      newX = Math.max(0, Math.min(newX, window.innerWidth - el.offsetWidth));
      newY = Math.max(0, Math.min(newY, window.innerHeight - el.offsetHeight));

      el.style.left = `${newX}px`;
      el.style.top = `${newY}px`;
    };

    const onMouseUp = () => {
      dragging = false;
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
      el.style.cursor = "grab";
    };

    const onMouseDown = (e) => {
      // ✅ 交互元素：不要启动拖拽
      if (isInteractive(e.target)) return;

      e.preventDefault();

      dragging = true;
      el.style.cursor = "grabbing";

      shiftX = e.clientX - el.getBoundingClientRect().left;
      shiftY = e.clientY - el.getBoundingClientRect().top;

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    };

    el.addEventListener("mousedown", onMouseDown);

    el.ondragstart = () => false;
  },
};
